
import layerEvents from "../utils/layerEvents";
import atlasApi from "../utils/atlasapi";


class Workmode {

	costs = {
		Sweden: {
			cost: 15,
			currency: "krono"
		},
		Estonia: {
			cost: 3,
			currency: "Euro"
		}
	}
	constructor() {
		

	}
	clear(){
		
	}
	getCountry(){
		return this.context.getters.project.country;
	}
	
	fetchOwnersCost(count){
		
		if(!count || !['Estonia', "Sweden"].includes(this.context.getters.project.country))
			return '';
		
		
		return '('+Math.ceil(this.costs[this.context.getters.project.country].cost*count) + ' '+ this.costs[this.context.getters.project.country].currency + ')'
		
	}
	contextMenu(){
		return [];
	}

	
	fetchOwner(vindrId, country){
		
		vindrId = Array.isArray(vindrId) ? vindrId : [vindrId];
		
		
		return atlasApi.getPlotInfo(vindrId, country);
		
	}

}

export default Workmode;